import { memo } from 'react';

import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

import AppBreadcrumbs from '@components/common/AppBreadcrumbs';
import PageHeader from '@components/layout/PageHeader';
import PageShell from '@components/layout/PageShell';

const AppPage = memo(function AppPage({
  title,
  subtitle,
  breadcrumbs = [],
  actions,
  children,
  maxWidth,
  ...rest
}) {
  return (
    <PageShell maxWidth={maxWidth === false ? '100%' : undefined} {...rest}>
      {breadcrumbs.length > 0 ? (
        <Box sx={{ mb: 2 }}>
          <AppBreadcrumbs items={breadcrumbs} />
        </Box>
      ) : null}
      {(title || actions) && <PageHeader title={title} subtitle={subtitle} actions={actions} />}
      <Box>{children}</Box>
    </PageShell>
  );
});

AppPage.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      href: PropTypes.string,
    }),
  ),
  actions: PropTypes.node,
  children: PropTypes.node,
  maxWidth: PropTypes.oneOfType([
    PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]),
    PropTypes.number,
  ]),
};

export default AppPage;
